import { Expose } from 'class-transformer';
import { MedicalStatusEnum } from '../../../../components/pages/book-fitness/BookFitness/medical-status.enum';

export class UserMedicalFormDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'updated_by' })
  updatedBy: number;
  @Expose({ name: 'form' })
  form: string;
  @Expose({ name: 'medical_status' })
  medicalStatus: MedicalStatusEnum;
  @Expose({ name: 'expiration_date' })
  expirationDate: Date;
  @Expose({ name: 'medical_certificate' })
  medicalCertificate: string;
  @Expose({ name: 'terms' })
  terms: Date;
  @Expose({ name: 'did_gym_tour' })
  didGymTour: boolean;
  @Expose({ name: 'created_at' })
  createdAt: Date;
  @Expose({ name: 'updated_at' })
  updatedAt: Date;
  @Expose({ name: 'deleted_at' })
  deletedAt: Date;
}
